import { X } from "lucide-react";

export function Toast({
  message,
  tone = "info",
  onClose
}: {
  message: string;
  tone?: "info" | "success" | "error";
  onClose: () => void;
}) {
  return (
    <div className={`toast ${tone}`} role="status">
      <span>{message}</span>
      <button className="icon-button" onClick={onClose} aria-label="Dismiss">
        <X size={18} />
      </button>
    </div>
  );
}

